"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectStatus = exports.MouseListenerType = exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    /**
     * Sending messages in the main thread.
     * Add MAIN for easy identification.
    */
    MessageType["MAIN_CONNECT_WIDGET"] = "MAIN_CONNECT_WIDGET";
    MessageType["MAIN_INIT_WIDGET_DATA"] = "MAIN_INIT_WIDGET_DATA";
    MessageType["MAIN_SYNC_WIDGET_CONFIG"] = "MAIN_SYNC_WIDGET_CONFIG";
    MessageType["MAIN_REFRESH_WIDGET"] = "MAIN_REFRESH_WIDGET";
    MessageType["MAIN_SYNC_COMMAND_RESULT"] = "MAIN_SYNC_COMMAND_RESULT";
    MessageType["MAIN_SYNC_ACTION"] = "MAIN_SYNC_ACTION";
    MessageType["MAIN_SYNC_RECORD_PICKER_RESULT"] = "MAIN_SYNC_RECORD_PICKER_RESULT";
    /**
     * Sending messages in the widget.
     * Add WIDGET for easy identification.
     */
    MessageType["WIDGET_CONNECT"] = "WIDGET_CONNECT";
    MessageType["WIDGET_CONNECT_ES"] = "WIDGET_CONNECT_ES";
    MessageType["WIDGET_SYNC_COMMAND"] = "WIDGET_SYNC_COMMAND";
    MessageType["WIDGET_EXPAND_RECORD"] = "WIDGET_EXPAND_RECORD";
    MessageType["WIDGET_EXPAND_RECORD_PICKER"] = "WIDGET_EXPAND_RECORD_PICKER";
    MessageType["WIDGET_MOUSE_EVENT"] = "WIDGET_MOUSE_EVENT";
    MessageType["WIDGET_SYNC_WIDGET_CONFIG"] = "WIDGET_SYNC_WIDGET_CONFIG";
    MessageType["WIDGET_EXPAND_DEV_CONFIG"] = "WIDGET_EXPAND_DEV_CONFIG";
    MessageType["WIDGET_FETCH_VIEW"] = "WIDGET_FETCH_VIEW";
    MessageType["WIDGET_FETCH_DATASHEET"] = "WIDGET_FETCH_DATASHEET";
    MessageType["WIDGET_SUBSCRIBE_CHANGE"] = "WIDGET_SUBSCRIBE_CHANGE";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
var MouseListenerType;
(function (MouseListenerType) {
    MouseListenerType["ENTER"] = "mouseenter";
    MouseListenerType["LEAVE"] = "mouseleave";
})(MouseListenerType = exports.MouseListenerType || (exports.MouseListenerType = {}));
var ConnectStatus;
(function (ConnectStatus) {
    // No connection established.
    ConnectStatus[ConnectStatus["CLOSED"] = 0] = "CLOSED";
    // Connection is established, but no data can be sent or received.
    ConnectStatus[ConnectStatus["SYN_SENT"] = 1] = "SYN_SENT";
    // The ability to send and receive data has been confirmed.
    ConnectStatus[ConnectStatus["ESTABLISHED"] = 2] = "ESTABLISHED";
})(ConnectStatus = exports.ConnectStatus || (exports.ConnectStatus = {}));
